const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源一站聚合',
    desc: '整合西瓜视频、樱花视频、糖豆视频、樱桃视频等10+主流平台资源，覆盖电影、电视剧、综艺、动漫、纪录片等全品类，50万+影视内容随心看。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅不缓冲',
    desc: '智能CDN加速与多线路自动切换技术，支持1080P超清画质播放。根据网络环境自动优化码率，确保流畅观影，告别卡顿等待。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费无需注册',
    desc: '所有资源免费开放，无需注册登录，无隐藏收费。打开即看，即点即播。每日定时更新3000+内容，热播剧集第一时间同步上线。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-wide mb-2">平台特色</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">为什么选择糖心视频</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {features.map((feat, idx) => (
            <div key={idx} className="text-center p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
              <span className="inline-flex w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100/70 items-center justify-center mb-5">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </span>
              <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}